import {
  SchemaDefinition,
  SchemaTransformError,
  UnknownSchema
} from '@rehaje/core'

import type { ComponentSpecific } from './TypedNode'

export interface SchemaComponentSpecific extends RehajeSchemaMetadata {
  /**
   * 组件默认配置
   */
  default?: ComponentSpecific
  type: 'Schema.Component'
}

export class SchemaComponentDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaComponentSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaComponentSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(
    target: any,
    schema: SchemaComponentSpecific
  ): SchemaComponentSpecific {
    return this.inferOnlySchema(schema)
  }

  override inferOnlySchema(
    schema: SchemaComponentSpecific
  ): SchemaComponentSpecific {
    return {
      ...schema,
      type: 'Schema.Component'
    }
  }

  override inferTypeScript(): string {
    return this.interface
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaComponentSpecific,
    path: PropertyKey[] = []
  ) {
    if (this.test(target, schema, path)) return target
    if (target !== schema.fallback)
      this.raise(new SchemaTransformError(schema.name))
    return target
  }

  override validate(target: any, schema: SchemaComponentSpecific) {
    this.validateMetadata(target, schema, (target) => {
      return typeof target === 'function' || this.isRelationSpecific(target)
    })
  }
}

declare global {
  export interface RehajeSpecifics {
    'Schema.Component': SchemaComponentSpecific
  }
}
